import "./Industries.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Portfolio from "./sections/Portfolio";
import Contact from "./sections/Contact";
import IndustriesContact from "./sections/IndustriesContact";
import Footer from "@/reusable_sections/Footer";
export default function IndustriesPage() {
  return <div>
      <Header />
      <Hero />
      <Portfolio />
      <Contact />
      <IndustriesContact />
      <Footer />
    </div>;
}